import { FocusError } from 'focus-formik-error';
import { useFormik } from 'formik';
import * as Yup from "yup";
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from "js-cookie"

const AddRolesForm = ({ listing, adminMainUrl, handleCloseAdd, reloadComponent }) => {
    // Formik setup

    const navigate = useNavigate();
    const [disable, setDisable] = useState(false);


    const formik = useFormik({
        initialValues: {
            name: '',
            permissionList: [],
        },
        validationSchema: Yup.object({
            name: Yup.string().required('Please enter Role name.'),
            permissionList: Yup.array().min(1, 'At least one permission must be selected')
        }),
        onSubmit: (values, { resetForm }) => {
            setDisable(true);
            try {
                const token = Cookies.get('token');
                let config = {
                    method: "GET",
                    headers: {
                        'auth-token': token,
                        'Content-Type': 'application/json',
                    }
                };

                axios.post(`${adminMainUrl}/api/role/create`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            setDisable(false);
                            // navigate('/flexichain/roles/list');
                            resetForm();
                            handleCloseAdd();
                            reloadComponent();
                            toast.success(response?.data?.msg)
                        } else {
                            setDisable(false);
                            toast.error(response?.data?.msg)
                        }
                    }).catch(error => {
                        setDisable(false);
                        console.log(error.message);
                        toast.error(error?.response?.data?.msg)
                    })
            } catch (error) {
                setDisable(false);
                console.log(error.message);
                toast.error(error?.response?.data?.msg)
            }
        },
    });

    const handleHeadCheckboxChange = (module) => {
        // Check if the module is currently in the permissionList
        const existingModule = formik.values.permissionList.find(
            (permModule) => permModule.module_short_name === module.short_name
        );

        if (existingModule) {
            // If the module exists, it means the head checkbox is currently checked
            // We need to toggle the state of all permissions for this module
            const updatedPermissions = formik.values.permissionList.filter(
                (permModule) => permModule.module_short_name !== module.short_name
            );
            formik.setFieldValue('permissionList', updatedPermissions);
        } else {
            // If the module does not exist, we need to add all permissions for this module
            const newModulePermissions = {
                module_short_name: module.short_name,
                permission_list: module.permission.map((p) => ({
                    permission_short_name: p.short_name,
                })),
            };
            const updatedPermissions = [...formik.values.permissionList, newModulePermissions];
            formik.setFieldValue('permissionList', updatedPermissions);
        }
    };



    const handlePermissionCheckboxChange = (module, permission) => {
        const moduleIndex = formik.values.permissionList.findIndex(
            (permModule) => permModule.module_short_name === module.short_name
        );

        let updatedPermissions = [...formik.values.permissionList];
        let existingModule;

        if (moduleIndex > -1) {
            existingModule = { ...updatedPermissions[moduleIndex] };  // Copy the existing module
            const permissionIndex = existingModule.permission_list.findIndex(
                (perm) => perm.permission_short_name === permission.short_name
            );

            if (permissionIndex > -1) {
                // Uncheck the permission
                existingModule.permission_list.splice(permissionIndex, 1);

                // Remove the entire module if no permissions are left
                if (existingModule.permission_list.length === 0) {
                    updatedPermissions.splice(moduleIndex, 1);
                } else {
                    updatedPermissions[moduleIndex] = existingModule; // Update the existing module in the list
                }
            } else {
                // Check the permission
                existingModule.permission_list.push({
                    permission_short_name: permission.short_name,
                });
                updatedPermissions[moduleIndex] = existingModule; // Update the existing module in the list
            }
        } else {
            // Add new module with the selected permission
            updatedPermissions.push({
                module_short_name: module.short_name,
                permission_list: [{ permission_short_name: permission.short_name }],
            });
        }

        formik.setFieldValue('permissionList', updatedPermissions);
    };
    return (
        <>
            <div className="container">
                <div className="col-md-12">
                    <div className="main_section_detail">
                        {/* <div className="main-nav-det">
                            <h2>Add Role Form</h2>
                        </div> */}
                        <form onSubmit={formik.handleSubmit}>
                            <FocusError formik={formik} />
                            <div className="main_detail_form">
                                {/* <div className="main-nav-det">
                                    <h4>Role information</h4>
                                </div> */}
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="input_box_section ">
                                            <label>
                                                Role Name <span>*</span>
                                            </label>
                                            <input
                                                type="text"
                                                name="name"
                                                className="form-control"
                                                placeholder="Enter Role here"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.name}
                                            />
                                            {formik.touched.name && formik.errors.name ? (
                                                <div className="text-danger small">{formik.errors.name}</div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>

                                <div className="main-nav-det">
                                    <h4>Assign Permissions</h4>
                                </div>
                                <div className="row">
                                    {listing.length > 0 ? (
                                        listing.map((module, index) => {
                                            const isHeadChecked = formik.values.permissionList.some(
                                                (permModule) =>
                                                    permModule.module_short_name === module.short_name &&
                                                    permModule.permission_list.length === module.permission.length
                                            );
                                            return <div key={index} className="col-md-4 mb-3">
                                                <div
                                                    className="table-responsive role_css acl-role"
                                                    style={{ height: '200px', overflowY: 'scroll', margin: '10px 0px' }}
                                                >
                                                    <table className="table table-striped permission_table">
                                                        <tbody>
                                                            <tr>
                                                                <th className='color-black'>{module.name}</th>
                                                                <th style={{ width: 40 }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        className="modulePerm"
                                                                        // name={`permissionList.${module.short_name}`}
                                                                        checked={isHeadChecked}
                                                                        // checked={formik.values.permissionList.some(
                                                                        //   (permModule) => permModule.module_short_name === module.short_name
                                                                        // )}
                                                                        onChange={() => handleHeadCheckboxChange(module)}
                                                                    />
                                                                </th>
                                                            </tr>
                                                            {module.permission.map((permission, i) => (
                                                                <tr key={i}>
                                                                    <td>{permission.name}</td>
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            // name={`permissionList.${module.short_name}`}
                                                                            checked={formik.values.permissionList.some(
                                                                                (permModule) =>
                                                                                    permModule.module_short_name === module.short_name &&
                                                                                    permModule.permission_list.some(
                                                                                        (perm) => perm.permission_short_name === permission.short_name
                                                                                    )
                                                                            )}
                                                                            onChange={() => handlePermissionCheckboxChange(module, permission)}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        })
                                    ) : (
                                        <div className="text-center">
                                            <i>No permission assigned for this role.</i>
                                        </div>
                                    )}
                                </div>

                                {formik.errors.permissionList && (
                                    <div className="text-danger small">At least one permission must be selected</div>
                                )}

                                <div className="d-flex align-items-center justify-content-end">
                                    {/* <button type="button" data-bs-dismiss="offcanvas" className="btn btn-light me-2">Cancel</button> */}
                                    <button type="submit" className="btn btn-primary" disabled={disable}>
                                        {disable ? <><i className="fas fa-spinner fa-spin"></i> Submit </> : "Submit"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddRolesForm